// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row___NR2w","radioRow":"SimpleQuestionBuilderModal_radioRow__2_3Dg"};